var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play button"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 120870",
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "#767676",
    stroke: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Play",
    d: "M20 18.0718L32 25L20 31.9282L20 18.0718Z",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonIcon);
export default __webpack_public_path__ + "static/media/PlayButtonIcon.29629df00540356d845f5d3fcdc64350.svg";
export { ForwardRef as ReactComponent };